(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-buy-bar')) {
    customElements.define(
      'sticky-buy-bar',
      class StickyBuyBar extends HTMLElement {
        connectedCallback() {
          this.cta = this.querySelector('[data-sticky-buy-cta]');
          this.trigger = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
          this.buyBox = document.getElementById(this.dataset.buyBoxId);
          this.highlightTimer = null;

          this.cta?.addEventListener('click', () => this.onCtaClick());

          // Once a model is chosen the bar becomes an Add to Cart button for that variant.
          this.defaultLabel = this.cta?.textContent.trim();
          this.onVariantInputChange = (event) => {
            if (event.target.matches?.('input[name="id"]')) this.syncWithForm();
          };
          document.addEventListener('change', this.onVariantInputChange);
          // variantChange fires after the submit button label has been updated.
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, () => this.syncWithForm());
          }
          this.syncWithForm();
          window.addEventListener('load', () => this.syncWithForm(), { once: true });

          if (!this.trigger) return;

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const shouldShow = !entry.isIntersecting;
                this.classList.toggle('is-visible', shouldShow);
                this.toggleAttribute('aria-hidden', !shouldShow);
              });
            },
            { threshold: 0, rootMargin: '0px' }
          );
          this.observer.observe(this.trigger);
        }

        prefersReducedMotion() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        getHighlightTarget() {
          const root = this.buyBox;
          if (!root) return null;

          return (
            root.querySelector('.model_product-variant-options')?.closest('fieldset') ||
            root.querySelector('.model-swatches_box') ||
            root.querySelector('.color_swatchs_block')?.closest('fieldset') ||
            root.querySelector('variant-selects .product-form__input') ||
            root.querySelector('variant-selects') ||
            root
          );
        }

        headerOffset() {
          const header = document.querySelector('.section-header sticky-header, .section-header, #shopify-section-header');
          return header ? Math.ceil(header.getBoundingClientRect().height) : 0;
        }

        scrollToBuyBox() {
          if (!this.buyBox) return Promise.resolve();

          const top = this.buyBox.getBoundingClientRect().top + window.scrollY - this.headerOffset() - 12;
          const behavior = this.prefersReducedMotion() ? 'auto' : 'smooth';

          window.scrollTo({ top: Math.max(0, top), behavior });

          if (behavior === 'auto') return Promise.resolve();

          return new Promise((resolve) => {
            let settled = false;
            const finish = () => {
              if (settled) return;
              settled = true;
              window.removeEventListener('scrollend', finish);
              clearTimeout(fallback);
              resolve();
            };
            const fallback = setTimeout(finish, 700);
            window.addEventListener('scrollend', finish, { once: true });
          });
        }

        highlightDecisionRow() {
          const target = this.getHighlightTarget();
          if (!target) return;

          target.classList.remove('sticky-buy-bar-highlight');
          void target.offsetWidth;
          target.classList.add('sticky-buy-bar-highlight');

          clearTimeout(this.highlightTimer);
          this.highlightTimer = setTimeout(() => {
            target.classList.remove('sticky-buy-bar-highlight');
          }, this.prefersReducedMotion() ? 1000 : 1100);
        }

        fireAnalytics() {
          const detail = {
            product_handle: this.dataset.productHandle || '',
            template: this.dataset.template || '',
          };

          document.dispatchEvent(new CustomEvent('sticky_buy_bar_click', { detail, bubbles: true }));

          if (Array.isArray(window.dataLayer)) {
            window.dataLayer.push({
              event: 'sticky_buy_bar_click',
              product_handle: detail.product_handle,
              template: detail.template,
            });
          }

          if (typeof window.gtag === 'function') {
            window.gtag('event', 'sticky_buy_bar_click', {
              product_handle: detail.product_handle,
              template: detail.template,
            });
          }
        }

        get productForm() {
          return document.getElementById(`product-form-${this.dataset.section}`);
        }

        hasSelectedVariant() {
          if (this.dataset.requireModel !== 'true') return false;
          return Boolean(this.productForm?.querySelector('input[name="id"]')?.value);
        }

        syncWithForm() {
          if (!this.cta) return;
          if (!this.hasSelectedVariant()) {
            this.cta.textContent = this.defaultLabel;
            return;
          }
          const label = this.trigger?.querySelector(':scope > span')?.textContent.trim();
          this.cta.textContent = label || 'Add to Cart';
        }

        async onCtaClick() {
          if (this.hasSelectedVariant()) {
            if (this.trigger && !this.trigger.disabled) this.productForm.requestSubmit(this.trigger);
            return;
          }

          this.fireAnalytics();
          await this.scrollToBuyBox();
          this.highlightDecisionRow();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          document.removeEventListener('change', this.onVariantInputChange);
          this.unsubscribeVariantChange?.();
          clearTimeout(this.highlightTimer);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
